/*
  Collection filter drawer as an accordion (filter_type "drawer"; markup in snippets/facets.liquid).
  Dawn's <menu-drawer> treats every <summary> inside it as a sliding sub-panel and traps focus in it. In the
  accordion the filter groups open in place, so their summary clicks are stopped before menu-drawer sees them
  (capture phase); the native <details> toggle still happens. Dawn closes every group when the drawer closes,
  so the groups marked data-nlf-default-open (Class, Length) are reopened each time the drawer opens.
*/
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('.nlf-facets-accordion summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (details && details.classList.contains('mobile-facets__details')) {
        event.stopPropagation();
        return;
      }
      if (summary.classList.contains('mobile-facets__open-wrapper')) {
        var drawer = summary.closest('.nlf-facets-accordion');
        setTimeout(function () {
          drawer.querySelectorAll('details[data-nlf-default-open]').forEach(function (d) {
            d.setAttribute('open', '');
          });
        }, 0);
      }
    },
    true
  );
})();

/*
  Chat bubble (Tidio app embed) hidden while the filter drawer is open (owner 2026-11-01, option A): on phones the
  "Talk to an Expert!" bubble covered the drawer's Apply button. Uses Tidio's documented tidioChatApi.hide()/show().
  Watches the drawer's <details open> attribute, so it also works after a filter re-renders the drawer markup.
  If Tidio is not loaded yet, the state is applied when it fires tidioChat-ready. Only this script hides the chat.
*/
(function () {
  var chatHidden = false;
  function syncChat() {
    var drawerOpen = !!document.querySelector('.mobile-facets__disclosure[open]');
    if (drawerOpen === chatHidden) return;
    var api = window.tidioChatApi;
    if (!api || typeof api.hide !== 'function') return;
    if (drawerOpen) {
      api.hide();
    } else {
      api.show();
    }
    chatHidden = drawerOpen;
  }
  new MutationObserver(syncChat).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true
  });
  document.addEventListener('tidioChat-ready', syncChat);
})();
